import { SignalServiceBase } from "cayo.ui";
import { Entity } from "@cayo/shared/api/types/cayo-graph";
import { ActionParameters } from "@cayo/shared/api/types/schema";
import { FormProps } from "@cayo/shared/components/Form/types";
import { nameofFactory } from "@cayo/shared/utils/object";
import { urlUtils } from "@cayo/shared/utils/url";

const isStaticPage = () => {
  const hash = urlUtils.trim(window.location.hash).toLowerCase();

  return hash.endsWith("$value") || hash.endsWith("download");
};

export type showActionParams = {
  schemeId?: string;
  form?: FormProps;
  objects?: Entity[];
  independent?: boolean;
  onSaveComplete?: () => Promise<void>;
  reloadAfterClose?: boolean;
  package?: string;
  parameters?: any;
  actionParameters?: ActionParameters;
  template?: string;
  authMode?: string;
  controller?: AbortController;
  signingIn?: boolean;
};

export const showActionParamsNames = nameofFactory<showActionParams>();

export const appSignals = new SignalServiceBase<
  | "showAction"
  | "showWizardScheme"
  | "showClientWizard"
  | "showForm"
  | "showSavedQueryForm"
  | "handleAuth"
  | "queryIsRunning"
  | "queryIsEnd"
  | "signingIn"
  | "scopeSearchIsRunning"
  | "scopeSearchEnded",
  showActionParams
>();

export const appUtils = {
  isStaticPage,
};
